'use client';

import { createContext, useContext } from 'react';

interface ManualContextType {
  activeStep: number;
  setActiveStep: (step: number) => void;
  activePhoto: number;
  setActivePhoto: (photo: number) => void;
  sidebar: 'contents' | 'comments' | null;
  updateSidebar: (state: 'contents' | 'comments' | null) => void;
  steps: StepData[];
  guide: GuideData;
  siblings: GuideData[];
  categories: CategoryData[];
  initialComments: CommentsRestPayload[];
}

const ManualContext = createContext<ManualContextType | null>(null);

export function useManual() {
  const context = useContext(ManualContext);
  if (!context) {
    throw new Error('useManual must be used within ManualProvider');
  }
  return context;
}

export function ManualProvider({ children, ...props }: { children: React.ReactNode; value: ManualContextType }) {
  return <ManualContext.Provider value={props.value}>{children}</ManualContext.Provider>;
}
